<template>
  <page>
    <form data-vv-scope="batchGlUpdForm">
      <v-card>
        <!-- <v-toolbar dense color="grey lighten-3" flat>
          <v-toolbar-title v-if="(batchGlUpdForm.glSys !== '' && batchGlUpdForm.glSys !== 2)">Batch GL Update</v-toolbar-title>
          <v-toolbar-title v-if="(batchGlUpdForm.glSys !== '' && batchGlUpdForm.glSys === 2)">Batch GL Update - SUNGL</v-toolbar-title>
        </v-toolbar> -->
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap v-if="batchGlUpdForm.glSys !== '' && batchGlUpdForm.glSys === 2">
              <v-flex xs6 sm4 md3 xl2>
                <v-text-field
                  v-model="batchGlUpdForm.batchNo"
                  :label="batchGlUpdLabel.batchNo"
                  :error-messages="errors.collect('batchGlUpdForm.batchNo')"
                  data-vv-name="batchGlUpdForm.batchNo"
                  :data-vv-as="batchGlUpdLabel.batchNo"
                  @change="checkBatchNo"
                  v-validate="doValidateBatchNo"
                ></v-text-field>
              </v-flex>
              <!-- temporary remark this validation for testing
              <v-flex xs6 sm4 md3 xl2>
                <v-text-field v-model="batchGlUpdForm.acctPerMth" :label="batchGlUpdLabel.acctPerMth" :error-messages="errors.collect('batchGlUpdForm.acctPerMth')" data-vv-name="batchGlUpdForm.acctPerMth" :data-vv-as="batchGlUpdLabel.acctPerMth" @change="checkAcctPeriod" v-validate="doValidateAcctPerMth" :disabled="(batchGlUpdForm.batchNo !== '' && batchGlUpdForm.batchNo !== '0' && validBatchNo === true)"></v-text-field>
              </v-flex>
              <v-flex xs6 sm4 md3 xl2>
                <v-text-field v-model="batchGlUpdForm.acctPerYr" :label="batchGlUpdLabel.acctPerYr" :error-messages="errors.collect('batchGlUpdForm.acctPerYr')" data-vv-name="batchGlUpdForm.acctPerYr" :data-vv-as="batchGlUpdLabel.acctPerYr" v-validate="doValidateAcctPerYr" @change="checkAcctPeriod" :disabled="(batchGlUpdForm.batchNo !== '' && batchGlUpdForm.batchNo !== '0' && validBatchNo === true)">
                  <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                    <v-icon color="info" @click="showAcctPeriodHelpList = true" v-text="'mdi-magnify'" :disabled="(batchGlUpdForm.batchNo !== '' && batchGlUpdForm.batchNo !== '0' && validBatchNo === true)"></v-icon>
                  </v-slide-x-reverse-transition>
                </v-text-field>
              </v-flex>
              -->
              <v-flex xs6 sm4 md3 xl2>
                <v-text-field
                  v-model="batchGlUpdForm.acctPerMth"
                  :label="batchGlUpdLabel.acctPerMth"
                  :error-messages="errors.collect('batchGlUpdForm.acctPerMth')"
                  data-vv-name="batchGlUpdForm.acctPerMth"
                  :data-vv-as="batchGlUpdLabel.acctPerMth"
                  @change="checkAcctPeriod"
                  :disabled="batchGlUpdForm.batchNo !== '' && batchGlUpdForm.batchNo !== '0' && validBatchNo === true"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm4 md3 xl2>
                <v-text-field
                  v-model="batchGlUpdForm.acctPerYr"
                  :label="batchGlUpdLabel.acctPerYr"
                  :error-messages="errors.collect('batchGlUpdForm.acctPerYr')"
                  data-vv-name="batchGlUpdForm.acctPerYr"
                  :data-vv-as="batchGlUpdLabel.acctPerYr"
                  @change="checkAcctPeriod"
                  :disabled="batchGlUpdForm.batchNo !== '' && batchGlUpdForm.batchNo !== '0' && validBatchNo === true"
                >
                  <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                    <v-icon
                      color="info"
                      @click="showAcctPeriodHelpList = true"
                      v-text="'mdi-magnify'"
                      :disabled="batchGlUpdForm.batchNo !== '' && batchGlUpdForm.batchNo !== '0' && validBatchNo === true"
                    ></v-icon>
                  </v-slide-x-reverse-transition>
                </v-text-field>
              </v-flex>
              <v-flex xs6 sm4 md3 xl2>
                <cal-picker
                  v-model="batchGlUpdForm.tranDateSunGL"
                  :label="batchGlUpdLabel.tranDateSunGL"
                  :data-vv-as="batchGlUpdLabel.tranDateSunGL"
                  :error-messages="errors.collect('batchGlUpdForm.tranDateSunGL')"
                  data-vv-name="batchGlUpdForm.tranDateSunGL"
                  v-validate="doValidateSunGLDate"
                ></cal-picker>
              </v-flex>
              <v-flex xs6 sm4 md3 xl2>
                <v-checkbox color="primary" :label="batchGlUpdLabel.printChkListSunGLAE" v-model="batchGlUpdForm.printChkListSunGLAE"></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="batchGlUpdForm.glSys !== '' && batchGlUpdForm.glSys !== 2">
              <v-flex xs6 sm4 md3 xl2>
                <cal-picker
                  v-model="batchGlUpdForm.cutOffDate"
                  :label="batchGlUpdLabel.cutOffDate"
                  :data-vv-as="batchGlUpdLabel.cutOffDate"
                  :error-messages="errors.collect('batchGlUpdForm.cutOffDate')"
                  data-vv-name="batchGlUpdForm.cutOffDate"
                  v-validate="doValidateDate"
                ></cal-picker>
              </v-flex>
              <v-flex xs6 sm4 md3 xl2>
                <v-text-field
                  v-model="batchGlUpdForm.branch"
                  :label="batchGlUpdLabel.branch"
                  :error-messages="errors.collect('batchGlUpdForm.branch')"
                  data-vv-name="batchGlUpdForm.branch"
                  :data-vv-as="batchGlUpdLabel.branch"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('branch')"
                >
                  <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                    <v-icon color="info" @click="getHelpList('branch')"></v-icon>
                  </v-slide-x-reverse-transition>
                </v-text-field>
              </v-flex>
              <v-flex xs6 sm4 md3 xl2>
                <v-checkbox color="primary" :label="batchGlUpdLabel.printChkListAE" v-model="batchGlUpdForm.printChkListAE"></v-checkbox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" dark @click.prevent="doCancel">
            {{ actionLabel.cancel }}
            <v-icon dark right>mdi-exit-to-app</v-icon>
          </v-btn>
          <v-btn color="info" dark @click.prevent="doSubmit('schedule')" :loading="submitting">
            {{ actionLabel.schedule }}
            <v-icon dark right>mdi-calendar</v-icon>
          </v-btn>
          <v-btn color="primary" dark @click.prevent="doSubmit('run')" :loading="submitting">
            {{ actionLabel.submit }}
            <v-icon dark right>mdi-arrow-right-bold-box</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </form>
    <v-dialog v-model="HelpList" width="900px" persistent>
      <help-list :apiURI="apiURI" :mode="mode" :param="param" :boolRefresh="HelpList" @close="doClose" @doAssign="doAssign($event)"></help-list>
    </v-dialog>
    <v-dialog v-model="showAcctPeriodHelpList" width="1280px">
      <acct-period-help-list
        @close="showAcctPeriodHelpList = false"
        @assign-acct-period-info="assignAcctPeriod"
        :boolRefresh="showAcctPeriodHelpList"
        :modeNo="modeNo"
      ></acct-period-help-list>
    </v-dialog>
    <confirm v-model="promptReInstateCloseYear" @ok="doProceed">
      {{ promptMsg }}
    </confirm>
    <v-dialog v-model="promptWarnMsg" width="50%" persistent>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-card-title class="headline grey lighten-2" primary-title>
              Warning
              <v-spacer></v-spacer>
              <v-btn flat icon @click="closeDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-container fluid grid-list-sm>
                <v-layout row wrap>
                  <v-flex xs12>
                    {{ warnMsg }}
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-dialog>
    <v-dialog v-model="showAddSchedule" width="800px" persistent>
      <form data-vv-scope="batchJobForm">
        <v-card>
          <v-toolbar dense color="grey lighten-3" flat>
            <v-icon>mdi-clock</v-icon>
            <v-toolbar-title>Schedule Job</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <message :messages="messages"></message>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex md6 xs12>
                  <v-autocomplete
                    :items="jobNames"
                    v-model="batchFormField.jobName"
                    :label="batchFormLabel.jobName"
                    item-text="label"
                    item-value="value"
                    data-vv-name="batchFormField.jobName"
                    :data-vv-as="batchFormLabel.jobName"
                    :error-messages="errors.collect('batchFormField.jobName')"
                    v-validate="'required'"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex md6 xs12>
                  <v-autocomplete
                    :items="jobModes"
                    v-model="batchFormField.jobMode"
                    :label="batchFormLabel.jobMode"
                    item-text="label"
                    item-value="value"
                    data-vv-name="batchFormField.jobMode"
                    :data-vv-as="batchFormLabel.jobMode"
                    :error-messages="errors.collect('batchFormField.jobMode')"
                    v-validate="'required'"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex md6 xs12 v-if="batchFormField.jobMode === 'ONCE'">
                  <cal-picker
                    v-model="batchFormField.jobSchedule"
                    :label="batchFormLabel.jobSchedule"
                    :error-messages="errors.collect('batchFormField.jobSchedule')"
                    :data-vv-as="batchFormLabel.jobSchedule"
                    v-validate="'required'"
                    data-vv-name="batchFormField.jobSchedule"
                  ></cal-picker>
                </v-flex>
                <v-flex md12 xs12>
                  <v-dialog ref="dialog" v-model="timeModal" :return-value.sync="batchFormField.jobScheduleTime" persistent width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="batchFormField.jobScheduleTime"
                        v-validate="'required'"
                        :data-vv-as="batchFormLabel.jobScheduleTime"
                        data-vv-name="batchFormField.jobScheduleTime"
                        :error-messages="errors.collect('batchFormField.jobScheduleTime')"
                        :label="batchFormLabel.jobScheduleTime"
                        readonly
                        v-on="on"
                      >
                      </v-text-field>
                    </template>
                    <v-time-picker v-if="timeModal" v-model="batchFormField.jobScheduleTime" full-width>
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" text @click="timeModal = false">Cancel</v-btn>
                      <v-btn color="primary" text @click="$refs.dialog.save(batchFormField.jobScheduleTime)">OK</v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="showAddSchedule = false">Cancel</v-btn>
            <v-btn color="primary" text @click="submitSchedule('schedule')">Schedule</v-btn>
          </v-card-actions>
        </v-card>
      </form>
    </v-dialog>
  </page>
</template>

<script>
import routeMixin from '@/mixins/route'
import MessageMixin from '@/mixins/message'
import HelpList from '@/components/core/common/dialog/HelpList'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import AcctPeriodHelpList from '@/components/core/common/dialog/AcctPeriodHelpList'
import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'
import { expandURI } from '@/utils/ajax'
// import clone from 'clone'
import { extractMenu } from '@/utils/extract'

export default {
  data() {
    return {
      actionLabel: {
        cancel: 'Cancel',
        schedule: 'Schedule',
        submit: 'Submit'
      },
      batchGlUpdLabel: {
        cutOffDate: 'GL Transaction Cut-off Date',
        branch: 'Branch',
        printChkListAE: 'Print Check List',
        batchNo: 'Write records with Batch No.',
        acctPerMth: 'Accounting period Month',
        acctPerYr: 'Accounting period Year',
        tranDateSunGL: 'Transaction Date (Update to SUNGL)',
        printChkListSunGLAE: 'Print Check List'
      },
      batchGlUpdForm: {
        cutOffDate: new Date(),
        branch: 'All',
        printChkListAE: true,
        batchNo: '0',
        acctPerMth: '',
        acctPerYr: '',
        tranDateSunGL: new Date(),
        printChkListSunGLAE: true,
        glSys: '',
        jobId: null,
        jobName: '',
        jobSchedule: null,
        jobMode: '',
        jobScheduleTime: '',
        actionName: '',
        jobTimeKey: null,
        jobCron: null
      },
      miscacctparams: [],
      reportMenuLink: {},
      HelpList: false,
      mode: '',
      param: '',
      apiURI: '',
      showAcctPeriodHelpList: false,
      modeNo: '3',
      submitting: false,
      validBatchNo: true,
      validAcctPeriod: true,
      promptReInstateCloseYear: false,
      promptMsg: 'The Current Accounting Year is a reinstated closed year',
      isExistRecord: false,
      promptWarnMsg: false,
      warnMsg: '',
      showAddSchedule: false,
      timeModal: false,
      actionMame: '',
      jobs: [],
      batchFormField: {
        jobId: null,
        jobName: '',
        jobSchedule: null,
        jobMode: '',
        jobScheduleTime: '',
        actionName: '',
        jobTimeKey: null,
        jobCron: null
      },
      batchFormLabel: {
        jobName: 'Job Name',
        jobCron: 'Job Cron Expression',
        jobSchedule: 'Schedule Date',
        jobMode: 'Frequency',
        jobScheduleTime: 'Schedule Time'
      },
      jobNames: [{ label: 'Batch GL Update', value: 'qrtzBatchGLUpdate' }],
      jobModes: [{ label: 'Run Once', value: 'ONCE' }],
      jobWarningMessage: '',
      days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      selectedDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('batchGlUpdateInit')])
      await Promise.all([this.$store.dispatch('reportsInit')])
      await Promise.all([this.$store.dispatch('acctReportsInit')])
      if (this.$store.state.commons.init === 0) {
        await Promise.all([this.$store.dispatch('commonsInit')])
      }
      this.getReportMenuLink()
      this.getCommonData('miscacctparams').then((result) => {
        this.batchGlUpdForm.glSys = this.miscacctparams.glSys
        // this.batchGlUpdForm.glSys = 1 // For testing purpose
        if (this.batchGlUpdForm.glSys === 2) {
          // this.getDefAcctPeriod()
          var today = new Date()
          var iMonth = (today.getMonth() + 1).toString()
          var iYear = today.getFullYear().toString()
          this.batchGlUpdForm.acctPerMth = iMonth
          this.batchGlUpdForm.acctPerYr = iYear
        }
      })
    },
    getHelpList(fieldName) {
      this.mode = fieldName
      this.param = ''
      if (fieldName === 'branch') {
        this.apiURI = this.$store.state.commons.menu.getBranchList
        this.param = this.batchGlUpdForm.branch
      }
      this.HelpList = true
    },
    doAssign(Obj) {
      this.batchGlUpdForm.branch = Obj.finalSelectedItems.toString()
    },
    doClose() {
      this.HelpList = false
    },
    assignAcctPeriod(data) {
      this.resetValidator()
      this.resetMessages()
      this.validAcctPeriod = true
      this.batchGlUpdForm.acctPerMth = data.acctPerMth
      this.batchGlUpdForm.acctPerYr = data.acctPerYr
      this.showAcctPeriodHelpList = false
    },
    async checkBatchNo() {
      if (this.batchGlUpdForm.batchNo > 0) {
        this.batchGlUpdForm.acctPerMth = ''
        this.batchGlUpdForm.acctPerYr = ''
      }
      const apiUrl = this.$store.state.batchGlUpdate.menu.checkBatchNo
      if (apiUrl) {
        try {
          const expand = {
            batchNo: this.batchGlUpdForm.batchNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          if (data) {
            this.validBatchNo = data
          }
          this.validBatchNo = data
          return true
        } catch (err) {
          this.validBatchNo = false
          this.loading = false
          return false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        return false
      }
    },
    async checkAcctPeriod() {
      if (this.batchGlUpdForm.acctPerMth !== '' && this.batchGlUpdForm.acctPerYr !== '') {
        const apiUrl = this.$store.state.batchGlUpdate.menu.checkAcctPeriod
        if (apiUrl) {
          try {
            const expand = {
              modNo: this.modeNo,
              acctPerMth: this.batchGlUpdForm.acctPerMth,
              acctPerYr: this.batchGlUpdForm.acctPerYr
            }
            const result = await this.$http.get(expandURI(apiUrl, expand))
            const { data } = result.data
            if (data) {
              this.validAcctPeriod = data
            }
            this.validAcctPeriod = data
            return true
          } catch (err) {
            this.loading = false
            return false
          }
        } else {
          this.errorMessage('The request failed because it is trying to execute an invalid API url.')
          return false
        }
      } else {
        return true
      }
    },
    async getDefAcctPeriod() {
      const apiURI = this.$store.state.batchGlUpdate.menu.getAcctPeriodMod3
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.batchGlUpdForm.acctPerMth = data.acctPeriod.acctPerMth
          this.batchGlUpdForm.acctPerYr = data.acctPeriod.acctPerYr
        }
      }
    },
    doCancel() {
      this.$router.push({ name: 'generalLedger' }).catch(() => {})
    },
    submitSchedule(actionName) {
      this.resetMessages()
      this.$validator.validateAll('batchJobForm').then((result) => {
        if (result) {
          // this.generateCronExpression()
          this.batchFormField.actionName = actionName
          this.processRequest()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doSubmit(actionName) {
      this.actionName = actionName
      this.batchGlUpdForm.actionName = actionName

      this.checkBatchNo().then((result) => {
        if (result) {
          if (this.batchGlUpdForm.glSys === 2) {
            this.checkAcctPeriod().then((result) => {
              if (result) {
                this.$validator.validateAll('batchGlUpdForm').then((result) => {
                  if (result) {
                    this.doProceed()
                  }
                })
              }
            })
          } else {
            this.$validator.validateAll('batchGlUpdForm').then((result) => {
              if (result) {
                this.doCheckReInstate()
              }
            })
          }
        }
      })
    },
    generateCronExpression() {
      let timeSplit = this.batchFormField.jobScheduleTime.split(':')
      if (this.selectedDays.length === 7) {
        this.batchFormField.jobCron = '0 ' + Number(timeSplit[1]) + ' ' + Number(timeSplit[0]) + ' ? * *'
      } else {
        this.batchFormField.jobCron = '0 ' + Number(timeSplit[1]) + ' ' + Number(timeSplit[0]) + ' ? * ' + this.selectedDays.toString()
      }
    },
    async processRequest() {
      this.resetMessages()
      const apiURI = this.$store.state.batchGlUpdate.menu.batchGLUpdateSchedule
      if (apiURI) {
        try {
          if (this.batchGlUpdForm.actionName === 'schedule') {
            this.batchGlUpdForm.jobId = this.batchFormField.jobId
            this.batchGlUpdForm.jobName = this.batchFormField.jobName
            this.batchGlUpdForm.jobSchedule = this.batchFormField.jobSchedule
            this.batchGlUpdForm.jobMode = this.batchFormField.jobMode
            this.batchGlUpdForm.jobScheduleTime = this.batchFormField.jobScheduleTime
            this.batchGlUpdForm.actionName = this.batchFormField.actionName
            this.batchGlUpdForm.jobTimeKey = this.batchFormField.jobTimeKey
            this.batchGlUpdForm.jobCron = this.batchFormField.jobCron
          }
          const result = await this.$http.post(apiURI, this.batchGlUpdForm)
          const { data } = result
          if (data) {
            if (this.batchFormField.actionName === 'schedule') {
              this.$toast.success('Job successfully scheduled.')
            } else {
              this.$toast.success('Generating reports.')
            }
            // this.fetchBatchJobs()
            this.showAddSchedule = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.processingFlag = false
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doCheckReInstate() {
      const apiURI = this.$store.state.batchGlUpdate.menu.checkReInstate
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            if (data.reinstate === false) {
              this.promptReInstateCloseYear = true
            } else {
              this.doProceed()
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doProceed() {
      if (this.batchGlUpdForm.glSys === 2) {
        this.checkExistRecord().then((result) => {
          if (result) {
            if (this.isExistRecord === true) {
              // if (this.actionName === 'submit') {
              // this.generateBatchGLUpdateReport()
              if (this.actionName === 'run') {
                this.processRequest()
              } else {
                this.showAddSchedule = true
              }
            } else {
              if (this.batchGlUpdForm.batchNo !== '' && this.batchGlUpdForm.batchNo !== '0') {
                this.warnMsg = 'Invalid Batch No.'
                this.promptWarnMsg = true
              } else {
                this.warnMsg = 'No GL Transaction for this accounting Period.'
                this.promptWarnMsg = true
              }
            }
          }
        })
      } else if (this.batchGlUpdForm.glSys === 3 && this.batchGlUpdForm.printChkListAE === false) {
        // TODO need to check connection
        this.warnMsg = 'Not connected to Great Plains Integration DB'
        this.promptWarnMsg = true
      } else {
        if (this.actionName === 'run') {
          this.processRequest()
          // if (this.actionName === 'submit') {
          // this.generateBatchGLUpdateReport()
        } else {
          this.showAddSchedule = true
        }
      }
    },
    /*
    async generateBatchGLUpdateReport() {
      const apiURI = this.reportMenuLink.exportBatchGlReport
      let messageFilters = clone(this.batchGlUpdForm)
      if (apiURI) {
        this.$http.post(apiURI, messageFilters).then(result => {
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        })
      } else {
        this.$toast.error('An error encountered unable to print Batch Match Transaction Audit List record.')
      }
    },
    */
    async checkExistRecord() {
      const apiUrl = this.$store.state.batchGlUpdate.menu.isExistRecord
      if (apiUrl) {
        try {
          const expand = {
            batchNo: this.batchGlUpdForm.batchNo,
            acctPerMth: this.batchGlUpdForm.acctPerMth !== '' ? this.batchGlUpdForm.acctPerMth : -1,
            acctPerYr: this.batchGlUpdForm.acctPerYr !== '' ? this.batchGlUpdForm.acctPerYr : -1
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          this.isExistRecord = data
          return true
        } catch (err) {
          this.loading = false
          return false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        return false
      }
    },
    async getReportMenuLink() {
      try {
        const apiURI = this.acctMenu.batchGlUpd
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.reportMenuLink = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    closeDialog() {
      this.promptWarnMsg = false
    }
  },
  mounted() {
    this.doInit()
  },
  computed: {
    acctMenu() {
      return this.$store.state.reports.acctReports.menu
    },
    doValidateDate() {
      const today = new Date()
      return 'required|valDate:' + today
    },
    doValidateSunGLDate() {
      const minDate = new Date('Jan 01, 2019')
      const today = new Date()
      return 'entry|valMinDate:' + minDate + '|valMaxDate:' + today
    },
    doValidateAcctPerMth() {
      const maxMth = 13
      if (this.batchGlUpdForm.batchNo === '0') {
        return 'required|numeric|max:2|valAcctPerMth:' + maxMth + '|valIsAcctPerMth:' + this.validAcctPeriod
      } else {
        return ''
      }
    },
    doValidateAcctPerYr() {
      const maxYr = 2099
      if (this.batchGlUpdForm.batchNo === '0') {
        return 'required|numeric|max:4|valAcctPerYr:' + maxYr + '|valIsAcctPerYr:' + this.validAcctPeriod
      } else {
        return ''
      }
    },
    doValidateBatchNo() {
      if (this.batchGlUpdForm.batchNo !== '0' && this.validBatchNo === false) {
        return 'entry|valBatchNo:' + this.validBatchNo
      }
      return ''
    }
  },
  created() {
    this.$validator.extend('valDate', {
      getMessage(field, args) {
        return 'This date cannot be greater today'
      },
      validate(value, args) {
        let today = args[0]
        if (value) {
          return !isAfter(removeTime(value), removeTime(today))
        } else return true
      }
    })
    this.$validator.extend('valMaxDate', {
      getMessage(field, args) {
        return 'This date cannot be greater than today'
      },
      validate(value, args) {
        let maxDate = args[0]
        if (value) {
          return !isAfter(removeTime(value), removeTime(maxDate))
        } else return true
      }
    })
    this.$validator.extend('valMinDate', {
      getMessage(field, args) {
        return 'Date should be greater than 31/12/2018'
      },
      validate(value, args) {
        let minDate = args[0]
        if (value) {
          return !isAfter(removeTime(minDate), removeTime(value))
        } else return true
      }
    })
    this.$validator.extend('valAcctPerMth', {
      getMessage(field, args) {
        return 'Acctount Period Month 1 to 12'
      },
      validate(value, args) {
        let maxMth = args[0]
        if (value) {
          if (value > 0 && value < Number(maxMth)) {
            return true
          } else {
            return false
          }
        } else return true
      }
    })
    this.$validator.extend('valAcctPerYr', {
      getMessage(field, args) {
        return 'Acctount Period Year must greater than 2018 and less than 2099'
      },
      validate(value, args) {
        let maxYr = args[0]
        if (value) {
          if (value > 2018 && value < Number(maxYr)) {
            return true
          } else {
            return false
          }
        } else return true
      }
    })
    this.$validator.extend('valIsAcctPerMth', {
      getMessage(field, args) {
        return 'Invalid Account Period Month'
      },
      validate(value, args) {
        let isValidAcctPerMth = args[0]
        if (isValidAcctPerMth === 'false') {
          return false
        } else {
          return true
        }
      }
    })
    this.$validator.extend('valIsAcctPerYr', {
      getMessage(field, args) {
        return 'Invalid Account Period Year'
      },
      validate(value, args) {
        let isValidAcctPerYr = args[0]
        if (isValidAcctPerYr === 'false') {
          return false
        } else {
          return true
        }
      }
    })
    this.$validator.extend('valBatchNo', {
      getMessage(field, args) {
        return 'Invalid Batch No.'
      },
      validate(value, args) {
        let isValidBchNo = args[0]
        if (isValidBchNo === 'false') {
          return false
        } else {
          return true
        }
      }
    })
  },
  mixins: [routeMixin, MessageMixin, commonAjaxMixin],
  components: {
    HelpList,
    AcctPeriodHelpList
  }
}
</script>

<style lang="scss">
@import '../../../../assets/scss/accounting.scss';
</style>
